import React from "react";

const Services = () => {
  const services = [
    {
      name: "توسعه سایت و Web App اختصاصی",
      desc: "ساخت یا تکمیل سایت و پنل‌های اختصاصی با تمرکز بر تجربه‌ی کاربر، امنیت، عملکرد و امکان توسعه‌ی بعدی.",
      icon: "fas fa-code",
    },
    {
      name: "توسعه و تکمیل اپلیکیشن Mobile",
      desc: "پیاده‌سازی اپلیکیشن‌های iOS و Android، اتصال به Backend و آماده‌سازی مسیر محصول از Prototype تا نسخه‌ی قابل‌استفاده.",
      icon: "fas fa-mobile",
    },
    {
      name: "معماری و Backend محصول",
      desc: "طراحی API، دیتابیس و ساختار Backend برای محصولاتی که باید امن، قابل‌نگهداری و آماده‌ی رشد باشند.",
      icon: "fas fa-cloud",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">حوزه‌های تخصصی</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          راه‌حل فنی متناسب با پروژه‌ی شما
        </h2>

        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
